@tailwind base;
@tailwind components;
@tailwind utilities;

/* I colori di sistema iOS. Chiari di base; scuri sotto .scuro (oggi solo /misura). Canali RGB per i colori pieni, colore intero
   per etichette, riempimenti e separatori, che in iOS hanno già la loro trasparenza. */
:root {
  --c-fondo: 242 242 247;
  --c-scheda: 255 255 255;
  --c-testo: 0 0 0;
  --c-sec: rgba(60, 60, 67, 0.6);
  --c-ter: rgba(60, 60, 67, 0.3);
  --c-riemp: rgba(118, 118, 128, 0.12);
  --c-sep: rgba(60, 60, 67, 0.2);
  --c-segmento: 255 255 255;
  --c-blu: 0 122 255;
  --c-verde: 52 199 89;
  --c-verde-t: 36 138 61;
  --c-rosso: 255 59 48;
  --c-rosso-t: 196 23 13;
  --c-arancio: 255 149 0;
  --c-arancio-t: 179 95 0;
  --ombra-scheda: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 16px rgba(0, 0, 0, 0.06);
}

/* Modalità scura di iOS: fondo nero, schede grigio antracite, testi bianchi con trasparenza, colori di sistema più chiari. In scuro
   le schede non hanno ombra: si staccano dal fondo per il colore. */
.scuro {
  color-scheme: dark;
  --c-fondo: 0 0 0;
  --c-scheda: 28 28 30;
  --c-testo: 255 255 255;
  --c-sec: rgba(235, 235, 245, 0.6);
  --c-ter: rgba(235, 235, 245, 0.3);
  --c-riemp: rgba(118, 118, 128, 0.24);
  --c-sep: rgba(84, 84, 88, 0.65);
  --c-segmento: 99 99 102;
  --c-blu: 10 132 255;
  --c-verde: 48 209 88;
  --c-verde-t: 48 209 88;
  --c-rosso: 255 69 58;
  --c-rosso-t: 255 105 97;
  --c-arancio: 255 159 10;
  --c-arancio-t: 255 159 10;
  --ombra-scheda: none;
}

/* La pistola ha uno schermo da 4" (320×405 CSS px): niente zoom per doppio tocco, niente selezione accidentale. */
html,
body {
  height: 100%;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  overscroll-behavior: none;
  background-color: rgb(var(--c-fondo));
  color: rgb(var(--c-testo));
}

#root {
  min-height: 100dvh;
  padding-bottom: env(safe-area-inset-bottom);
}

/* L'anello di stabilità: si riempie col tempo fermo, non con i fotogrammi contati (lezione del simulatore). */
.anello {
  transition: stroke-dashoffset 120ms linear;
}
